
import React, { Component } from "react";
import { Button, HStack, Spacer } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";

import CreatableSelect from "react-select/creatable";

import CoreService from "../../../../services/CoreService";


Object.byString = function(o, s) 
{
    try
    {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        var a = s.split('.');
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (k in o) {
                o = o[k];
            } else {
                return;
            }
        }
    }
    catch(e)
    {
        return "";
    }
    return o;
}

const createOption = (label) => ({
    label,
    value: label,
});

const components = {
    DropdownIndicator: null
};


export default class MultiEntryApiLookupInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            valid: true,
            inputValue: "",
            value: [],
            descript: "",
            lookupButtonEnabled: false,
            inLookup: false,
            lookupError: false,
            lookupErrMsg: ""
        }

        this.coreService = new CoreService();

        this.onLookupButtonClick = this.onLookupButtonClick.bind(this);

    }


    componentDidMount()
    {
        if (this.props.valueBag[this.props.card.id])
        {
            var val = this.props.valueBag[this.props.card.id];
            var newState = val.map((v) => {return createOption(v)});
            this.setState({value: newState});
        }
    }


    handleChange = (value, actionMeta) => {
        if (actionMeta.action === "remove-value") {
            let tagValue = actionMeta.removedValue.value;
            this.props.onValueRemove(this.toTagId(tagValue));
        }
        var returnValue = [];
        if (value) {
            returnValue = value.map(v => {
                return v.value;
            });
        }
        this.props.onValueChange(returnValue, this.props.card.id);
        //this.props.onValueChange(this.toTagId(), returnValue);
        //this.onValidityCheck(this.state.enabled, returnValue);

        //this.setState({ value });

    };

    handleInputChange = (inputValue) => {
        this.setState({ inputValue });
    };


    handleKeyDown = (event) => {
        if (!this.state.inputValue) return;
        switch (event.key) {
            case 'Enter':
            case 'Tab':
                this.setValue(this.state.inputValue);
                this.setInputValue('');
                event.preventDefault();
        }
        var tempVal;
        if (this.state.value) {
            tempVal = this.state.value.map(v => {
                return v.value;
            });
        }
        this.props.onValueChange(tempVal);
    };


    setValue(val) {
        console.log(typeof (val))
        var newValArray
        if (typeof (val) === "string") {
            var newVal = createOption(val)
            newValArray = this.state.value
            newValArray.push(newVal)
        } else {
            newValArray = val
        }
        this.setState({
            value: newValArray
        })

        // this is returning an array of key Option objects (label, value pairs)

        // this.props.onValueChange(this.state.value);
    }

    setInputValue(val, actionMeta) {
        this.setState({
            inputValue: val
        })
    }

    async onLookupButtonClick(e)
    {
        this.setState({lookupErrMsg: ""});
        // we take the FIRST value in the list
        // TBD - move this to its own manager 
        var apiInfo = this.props.card.apiInfo;
        if (!apiInfo){
            this.setState({lookupErrMsg: "No Api Lookup Info available for this card"});
            return;
        }
        // here is where we would use alternate info if we are not using the current user session info
        var auth = {};
        auth.gcid = this.props.gcid,
        auth.token = this.props.token;

        var param1 = (Array.isArray(this.state.value) ? this.state.value[0].value: this.state.value);
        if (!param1)
        { 
            this.setState({lookupErrMsg: "Please enter at least one " + apiInfo.resultType});
            return;
        }

        // we ONLY support demo api currently.
        if (apiInfo.remoteApiInfo?.endpoints?.existsEndpoint)
        {
            var endpoint = apiInfo.remoteApiInfo?.endpoints?.existsEndPoint.replace("{param1}", param1);
            var existsResult = await this.coreService.fetchApiProxyUrl(apiInfo.remoteApiInfo?.proxyHost, endpoint, auth.gcid, auth.token);
            if (existsResult.hasError)
            {
                this.setState({lookupErrMsg: "There was an error checking if the " + apiInfo.resultType + " (" + param1 + ") exists."});
                return;
            }
        }

        if (apiInfo.remoteApiInfo?.endpoints?.fetchEndpoint)
        {
            var endpoint = apiInfo.remoteApiInfo?.endpoints?.fetchEndpoint.replace("{param1}", param1);
            var fetchResult = await this.coreService.fetchApiProxyUrl(apiInfo.remoteApiInfo?.proxyHost, endpoint, auth.gcid, auth.token);
            if (fetchResult.hasError)
            {
                this.setState({lookupErrMsg: "There was an error fetching the " + apiInfo.resultType + " with value " + param1 + " ."});
                return;
            }
            this.mapParsedFields(fetchResult.dataResult);
        }
    }


    mapParsedFields(parsedObject) 
    {
        var fieldMap = this.props.card.apiInfo.fieldMap;
        for (var key in fieldMap) {
          let entityField = fieldMap[key];
          var val = Object.byString(parsedObject, entityField);
          if (val) 
          {
            if (!this.repressOverwrite(key, this.props.valueBag, this.props.card.overwriteRules))
            {
                // we are NOT changing the current card here - only the mapped card
                this.props.onValueChange(val, key, false);
            }
          }
        }
      }


      repressOverwrite(key, valueBag, overwriteRules)
      {
          if (!overwriteRules) return false;
          if (overwriteRules.overAllProps) return false;
          if (!overwriteRules.doNotOverwriteProps) return false;
          if (! Array.isArray(overwriteRules.doNotOverwriteProps)) return false;
  
          var hasDoNotOverwriteKey = overwriteRules.doNotOverwriteProps.includes(key);
          if (!hasDoNotOverwriteKey) return false;
          var doNotOverwriteKeyIsInValueBag = (key in valueBag);
        if (!doNotOverwriteKeyIsInValueBag) return false;
        if ((valueBag[key].trim() === "") || (valueBag[key] == null)) return false;
        return true;
      }


    render() {
        const { inputValue, value } = this.state;
        return (
            <HStack width={"100%"}>

                <CreatableSelect
                    autoFocus
                    components={components}
                    inputValue={inputValue}
                    // options={formattedOptions}
                    isClearable
                    isMulti
                    menuIsOpen={false}
                    // isDisabled={false}
                    onChange={(newValue) => this.setValue(newValue)}
                    onInputChange={(newValue) => this.setInputValue(newValue, inputActionMeta)}
                    onKeyDown={this.handleKeyDown}
                    placeholder="Type Tag and Press Enter"
                    value={this.state.value}

                    styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            minHeight: '40px',
                            minWidth: '-webkit-fill-available',
                            marginRight: '10px'
                        }),
                        valueContainer: (baseStyles, state) => ({
                            ...baseStyles,
                            fontSize: '16px',
                            marginBottom: '10px',
                        })
                    }}
                />
                <Spacer />
                <Button className="multipallet-button"
                    disabled={!this.state.lookupButtonEnabled}
                    onClick={(e) => this.onLookupButtonClick(e)}
                    fontColor={(this.state.lookupError) ? "yellow" : "white"}
                    rightIcon={(this.state.inLookup) ? <FontAwesomeIcon icon={faSyncAlt} color="lightgreen" spin={true} /> : <span />}
                >
                    Lookup
                </Button>
                <div align="center" style={{ fontColor: "yellow" }}>
                    {this.state.lookupErrMsg}
                </div>
            </HStack>
        );
    }
}







